import React from 'react';

export const sceneFiveMeta = {
  id: 'green-latte-enzyme',
  title: '場景五｜品嘗綠拿鐵與酵素',
  excerpt: '在生態自然農場，慢慢品嘗綠拿鐵與酵素，理解土地、陽光、時間與生命。',
};

const SceneFiveGreenLatte: React.FC = () => (
  <article className="forest-article-detail">
    <h2>{sceneFiveMeta.title}</h2>
    <p>午後的陽光，輕輕灑落在農場。</p>
    <p>風吹過樹葉，蟲鳴鳥叫，沒有被城市的喧囂蓋過。</p>
    <p>孩子們坐在木桌旁，手上不是手搖飲，而是一杯剛現打的綠拿鐵，還有自然發酵的酵素。</p>
    <p>慢慢喝，慢慢感受。</p>
    <p>第一次發現：原來食物，不只是填飽肚子，而是土地、陽光、時間與生命的累積。</p>
    <p>老師沒有急著上課，只是帶孩子看看：</p>
    <ul>
      <li>菜葉上的露水</li>
      <li>土壤裡的蚯蚓</li>
      <li>鳥吃剩的桑椹果</li>
      <li>自然發酵的氣味</li>
    </ul>
    <p>孩子開始理解：真正活著的東西，是有生命力的。</p>
    <p>城市裡很多東西很快、很方便、很刺激，但也讓人越吃越累、越活越焦慮、越忙越空虛。</p>
    <p>而農場教人的，剛好相反。</p>
    <p>綠拿鐵不是流行，而是把植物真正的生命力，慢慢喝進身體。</p>
    <p>酵素不是神奇產品，而是時間與微生物一起完成的作品。</p>
    <p>很多真正好的東西都不能太快。像樹長大、土壤形成、酵素發酵、一個人成熟，都需要時間。</p>
    <blockquote>原來幸福，不是一直得到更多，而是能靜下來，好好感受生命。</blockquote>
  </article>
);

export default SceneFiveGreenLatte;
